import { createSelector } from 'reselect'
import filter from 'lodash/filter'
import orderBy from 'lodash/orderBy'
import { entities } from 'dux/api/action_types'
import { selectHasOrganizationResultsReadPermission } from 'selectors/user'
import { OrganizationFileTypes } from 'constants/organization_files'
import { createEntityGetter } from 'utils/selectors'

const getOrganizationId = state =>
  state.organizations.currentOrganizationId || null

export const selectSmartPulseOrganizationFiles = createSelector(
  createEntityGetter(entities.ORGANIZATION_FILES),
  getOrganizationId,
  selectHasOrganizationResultsReadPermission,
  (files, organizationId, hasOrgReadPermission) => {
    if (!hasOrgReadPermission) {
      return []
    }

    return orderBy(
      filter(
        files,
        file =>
          `${file.organizationId}` === `${organizationId}` &&
          (file.fileType === OrganizationFileTypes.SP_REPORT_TYPE_LEGACY ||
            file.fileType === OrganizationFileTypes.SP_REPORT_TYPE)
      ),
      ['id'],
      ['desc']
    )
  }
)
